import { UIViewSpec } from './view';

export const enum UIKey {
    Backspace = 'Backspace', Tab = 'Tab', Enter = 'Enter', Left = 'ArrowLeft', Up = 'ArrowUp', Right = 'ArrowRight', Down = 'ArrowDown',
    Space = ' ', Escape = 'Escape', Delete = 'Delete'
}

export interface UIKeyEvent {
    code: string;
    key: UIKey;
    repeat: boolean;
}

export type UIKeyHandler = (event: UIKeyEvent) => boolean | void;

export function onKey(where: UIViewSpec, handler: UIKeyHandler) {
    where.ui_elem.addEventListener('keydown', e => {
        if(handler({ code: e.code, key: e.key as UIKey, repeat: e.repeat }))
            e.preventDefault();
    });
}
